import { Button, Container, Grid, MenuItem, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GridContainer from '../../components/GridContainer'
import ProductCard from '../../components/Products/ProductCard'
import Selector from '../../components/Selector/Selector'
import { PRODUCT_ACTIONS } from '../../redux/actions'

const ProductsScreen = () => {

    const [per_page, setper_page] = useState(6)
    const [page, set_page] = useState(1)

    const dispatch = useDispatch()
    const getProducts = (params) => dispatch(PRODUCT_ACTIONS.getProductsAction(params))
    const loadMoreProducts = (params) => dispatch(PRODUCT_ACTIONS.loadMoreProducts(params))

    const products = useSelector(state => state.products.products)
    const loading = useSelector(state => state.products.loading)
    
    useEffect(() => {
        getProducts({ per_page: per_page })
    }, [per_page])

    useEffect(() => {
        if(page!==1){
            loadMoreProducts({ per_page: per_page, page: page })
        }
    }, [page])

    const handlePerPage = (e) => {
        setper_page(e.target.value)
    }

    return (
        <Container maxWidth="xl" disableGutters >
            <Grid container spacing={6} justify="flex-end" alignContent="flex-end"  >
                <Grid item xs={6} md={6} lg={2}  >
                    <Selector
                        label="Products per page"
                        onChange={handlePerPage}
                        value={per_page}
                        options={[
                            { label: "4", value: 4 },
                            { label: "6", value: 6 },
                            { label: "12", value: 12 },
                            { label: "24", value: 24 },
                            { label: "48", value: 48 },
                            { label: "72", value: 72 }]}
                    />
                </Grid>
                
            </Grid>

            <GridContainer loading={loading} list={products} component={<ProductCard />} />

            <Grid container spacing={6} justify="center" >
                <Grid item >
                    <Button 
                        onClick={()=>set_page(page+1)}
                        variant="contained" 
                        color="primary" >Load more</Button>
                </Grid>
            </Grid>

        </Container>
    )
}

export default ProductsScreen
